import classNames from 'classnames';
import { forwardRef } from 'react';

type PositionProps = React.PropsWithChildren<{
  className?: string;
  position?: Position;
  fixed?: boolean;
}>;

type Position = 'topLeft' | 'bottomLeft' | 'topRight' | 'bottomRight';

const positionClasses: Record<Position, string[]> = {
  topLeft: ['top-8 left-8', 'lg:top-12 lg:left-12'],
  topRight: ['top-8 right-8', 'lg:top-12 lg:right-12'],
  bottomLeft: ['bottom-8 left-8', 'lg:bottom-12 lg:left-12'],
  bottomRight: ['bottom-8 right-8', 'lg:bottom-12 lg:right-12'],
};

const commonClasses = '';

const Position = forwardRef<HTMLDivElement, PositionProps>(
  (props, forwardRef) => {
    const { children, className, position = 'topLeft', fixed } = props;

    const classes = classNames(
      commonClasses,
      ...positionClasses[position],
      fixed ? 'fixed' : 'absolute',
      className
    );

    return (
      <div ref={forwardRef} className={classes}>
        {children}
      </div>
    );
  }
);

Position.displayName = 'Position';

export default Position;
